export const recaptchaPromise = (RECAPTCHA_TOKEN) => new Promise((resolve, reject) => {
  /** @type {*} */
  const { grecaptcha } = window;

  if (!grecaptcha || !grecaptcha.execute) {
    return resolve(null);
  }

  return grecaptcha.ready(() => {
    return grecaptcha.execute(
      RECAPTCHA_TOKEN,
      {
        action: location.pathname.replace(/-/g, '').replace(/\./g, '')
      }
    )
      .then(resolve)
      .catch(reject);
  });
});
